module.exports = __webpack_public_path__ + "r-v3/img/ml_31_00.5d827525.jpg";